<template>
    <main role="main" class="compliance">
        <article class="layout-contents-container">
            <!-- Title -->
            <div class="layout-page-title">
                <h1 class="page-title">
                    {{ $t('MENU.COMPLIANCE')}}<!--Compliance-->
                </h1>
            </div>
            <!-- Title -->
            <div class="layout-contents">
                <fieldset class="tbl-filters" >
                    <legend>table filters</legend>
                    <div class="seperate" :key="getLocale">
                        <CVendorSelect
                            class="ui dropdown account-filter"
                            style="width: 141px;"
                            :placeholder="$t('FILTER.ACCOUNT')"
                            :options="getAllAccountFilterData"
                            :callOnSelect="changeFilterAcc"
                            :preSelected="getPresetAccount(filterAcc)"
                        />
                        <select-box-single
                            select-id="typeFilter"
                            select-class="type-single"
                            :select-box-value="searchType"
                            :select-box-options="constants.POLICY_TYPE_FILTER"
                            :use-translate="true"
                            @onSelectChange="changeSearchType($event.value)"></select-box-single>
                    </div>
                    <div class="search-box">
                        <input type="search"
                            :placeholder="$t('COMMON.SEARCH.ENTER_SEARCH_TEXT')"
                            v-model="searchTxt"
                            @keyup="setSearchText"
                            class="pr-0">
                        <button v-show="searchTxt !== ''" type="button" class="buttons-icon" data-type="ghost" data-size="s" data-icon="clear" v-on:click="clearSearchText">Reset</button>
                        <button type="button" class="btn-search" v-on:click="setSearchText">Search</button>
                    </div>
                </fieldset>
                <nav class="navigation-tab">
                    <h2 class="title">Sub Navigation</h2>
                    <button type="button" class="tab-item"
                        :class="{ 'selected' : getFilterStatus === constants.PARAM.SELECT.ALL }"
                        @click="setFilterStatus(constants.PARAM.SELECT.ALL)">{{ $t('COMPLIANCE.TAB.ALL')}}<!--전체-->
                            <span v-if="!this.searchSvrty" class="count">{{cmplCountStatus.allStatus}}</span></button>
                    <button type="button" class="tab-item"
                        :class="{ 'selected' : getFilterStatus === constants.PARAM.SELECT.COMPLIANCE }"
                        @click="setFilterStatus(constants.PARAM.SELECT.COMPLIANCE)">{{ $t('COMPLIANCE.TAB.COMPLIANT')}}<!--전체-->
                            <span v-if="!this.searchSvrty" class="count">{{cmplCountStatus.compliance}}</span></button>
                    <button type="button" class="tab-item"
                        :class="{ 'selected' : getFilterStatus === constants.PARAM.SELECT.NON_COMPLIANCE }"
                        @click="setFilterStatus(constants.PARAM.SELECT.NON_COMPLIANCE)">{{ $t('COMPLIANCE.TAB.NON_COMPLIANT')}}<!--검사 완료-->
                            <span v-if="!this.searchSvrty" class="count">{{cmplCountStatus.nonCompliance}}</span></button>
                </nav>

                <div class="tbl-actions">
                    <span v-if="getMenuAuth === constants.AUTH_TYPE.EDIT" class="seperate">
                      <button type="button" class="buttons" data-size="s" v-on:click="executeNewSelectCmpls" v-bind:disabled="(totalSlctCmplArray.length < 1) || (getCheckInspecting > 0)">{{ $t('COMPLIANCE.BUTTON.EVALUATE')}}<!--검사--></button>
                    </span>

                    <button v-if="getMenuAuth === constants.AUTH_TYPE.EDIT"
                        class="buttons"
                        data-type="line"
                        data-size="s"
                        :disabled="(totalSlctCmplArray.length < 1) || (getCheckInspecting > 0)"
                        @click="openRemoveCmplPopup">{{ $t('COMPLIANCE.BUTTON.REMOVE_FROM_EVAL_LIST')}}<!--검사 목록에서 제거-->
                    </button>
                    <button type="button" class="buttons" data-type="line" data-size="s" v-on:click="downloadListToCSV">{{$t('DASHBOARD.SUMMARY.BUTTON.CSV_DOWNLOAD')}}<!--CSV 다운로드--></button>

                    <div class="actions -mt-2" style="right: 0px !important;">
                        <span class="-description">{{ $t('LABEL.LAST_UPDATE')}} {{convertUtcTimezoneToLocal(lastCmplUpdtDt)}}</span> <!--Last updated 2023년 11월 16일 오후 6:27:14-->
                        <button type="button" class="buttons-icon" data-type="line" data-size="s" data-icon="refresh" @click="slctCmplList"></button>
                    </div>

                </div>

                <div-loading v-if="pending" :full="true"></div-loading>
                <div class="tbl-collapse" data-linkable-row>
                    <div class="thead">
                        <div class="row">
                            <span class="cell" data-size="status-ribbon"></span>
                            <span v-if="getMenuAuth === constants.AUTH_TYPE.EDIT" class="cell" data-size="checkbox">
                                <input type="checkbox" id="select-all" name="select-all" class="checkbox txt-none" v-model="selectCheckAll">
                                <label for="select-all">{{$t('LABEL.SELECT_ALL')}}</label>
                            </span>
                            <span class="cell" data-size="auto">
							<button type="button" class="buttons-tbl-header"
                                    v-bind:data-type="sortColumn !== 'titl' ? 'sort' : sortOrder === 'asc' ? 'sort-asce' : 'sort-desc'"
                                    v-on:click="setSortColumn('titl')">{{$t('LABEL.POLICY_NAME')}}<!--정책 이름--></button>
						    </span>
                            <span class="cell" data-size="status02" data-align="center">
                                <button type="button"
                                        :class="[isDisableSearchStatHeader ? 'disable-search-stat-header' : '']"
                                        :disabled="isDisableSearchStatHeader"
                                        class="buttons-tbl-header"
                                        data-type="filter"
                                        data-tooltip-content="#tooltip-stat-filter">{{ $t('LABEL.EVAL_STAT')}}</button>
                                <div class="tooltip_templates">
                                    <div id="tooltip-stat-filter">
                                        <ul class="list-filter">
                                            <li v-for="(stat, index) of constants.COMPLIANCE_STAT_FILTER" :key="index">
                                                <input
                                                    @change="handleStatHeader"
                                                    v-model="searchStatHeader"
                                                    :id="stat.key"
                                                    type="checkbox"
                                                    class="checkbox"
                                                    name="filter-type"
                                                    :value="stat.key">
                                                <label :for="stat.key">{{$t(stat.val)}}</label>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </span>
                            <span class="cell" data-size="score" data-align="center">
                                <button type="button" class="buttons-tbl-header"
                                        v-bind:data-type="sortColumn !== 'score' ? 'sort' : sortOrder === 'asc' ? 'sort-asce' : 'sort-desc'"
                                        v-on:click="setSortColumn('score')">{{$t('LABEL.EVAL_SCORE')}}<!--검사 점수--></button>
                            </span>
                            <span class="cell" data-size="schedule" data-align="center">
                                <button type="button" class="buttons-tbl-header" data-type="filter" data-tooltip-content="#tooltip-sche-filter">{{$t('LABEL.SCHEDULE')}}<!--스케줄--></button>
                                    <div class="tooltip_templates">
                                    <div id="tooltip-sche-filter">
                                        <ul class="list-filter">
                                            <li v-for="(stat, index) of constants.SCHE_STAT_FILTER" :key="index">
                                                <input
                                                    @change="handleStatHeader"
                                                    v-model="searchScheType"
                                                    :id="stat.key"
                                                    type="checkbox"
                                                    class="checkbox"
                                                    name="filter-type"
                                                    :value="stat.key">
                                                <label :for="stat.key">{{$t(stat.val)}}</label>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </span>
                            <span class="cell" data-size="date" data-align="center">
                                <button type="button" class="buttons-tbl-header"
                                        v-bind:data-type="sortColumn !== 'updtDt' ? 'sort' : sortOrder === 'asc' ? 'sort-asce' : 'sort-desc'"
                                        v-on:click="setSortColumn('updtDt')">{{$t('LABEL.APPLIED_ON')}}<!--적용일--></button>
                            </span>
                            <span class="cell" data-size="date" data-align="center">
                                <button type="button" class="buttons-tbl-header"
                                        v-bind:data-type="sortColumn !== 'execDt' ? 'sort' : sortOrder === 'asc' ? 'sort-asce' : 'sort-desc'"
                                        v-on:click="setSortColumn('execDt')">{{$t('LABEL.LAST_EVALUATION')}}<!--최근 검사--></button>
                            </span>
                            <span v-if="getMenuAuth === constants.AUTH_TYPE.EDIT" class="cell" data-size="management" data-align="center">
                                {{$t('LABEL.OPTIONS')}}<!--옵션-->
                            </span>
                            <span class="cell" data-align="center">
                                {{$t('LABEL.DETAILS')}}<!--상세-->
                            </span>
                        </div>
                    </div>
                    <div class="tbody" v-if="cmplList.length > 0">
                        <div class="row"  v-for="(cmpl, index) in cmplList" :data-checked="checkRow(cmpl)" :key="index">
                            <div class="cells">
                                <span class="cell" data-size="status-ribbon">
                                    <span class="ribbon-status"
                                          :data-type="cmpl.execDt == null || cmpl.cmplStat == constants.COMPLIANCE_STAT.EXAMINING ? 'waiting' : cmpl.cmplStat == constants.COMPLIANCE_STAT.PASS ? 'success' : cmpl.cmplStat == constants.COMPLIANCE_STAT.FAIL ? 'failer' : cmpl.cmplStat == constants.COMPLIANCE_STAT.ERROR ? 'failer' : null" title="미검사">{{ $t('COMPLIANCE.TAB.UNEXAMINED')}}</span>
                                </span>
                                <span v-if="getMenuAuth === constants.AUTH_TYPE.EDIT" class="cell" data-size="checkbox">
                                    <input type="checkbox"
                                    :disabled="cmpl.cmplStat == constants.COMPLIANCE_STAT.EXAMINING"
                                    :id="cmpl.cmplId" class="checkbox txt-none"  v-model="checkList" :value="cmpl">
                                    <label :for="cmpl.cmplId">{{$t('LABEL.SELECT')}}</label>
                                </span>
                                <span class="cell" data-size="auto" v-on:click="moveToDetail(cmpl, $event)">
                                    <div class="policy-item">
                                        <span v-if="cmpl.userDefiYn && cmpl.userDefiYn === constants.PARAM.SELECT.Y" class="icon-tag"  data-type="policy-custom">{{$t('TYPE.CUSTOM')}}<!--사용자 설정--></span>
                                        <span v-else-if="cmpl.userDefiYn && cmpl.userDefiYn === constants.PARAM.SELECT.N" class="icon-tag" data-type="policy-system">{{$t('TYPE.BEST_PRACTICE')}}<!--Best practice--></span>
                                            <template v-for="vendor in cmpl.vendors">
                                                <span v-bind:key="vendor" :data-vendor="getVendorIcon(vendor)" class="icon-vender txt-none" data-size="m"/>
                                            </template>
                                        <span class="name" :title="cmpl.userDefiYn === constants.PARAM.SELECT.N ? cmpl[$i18n.locale+'Title'] : cmpl.titl">{{cmpl.userDefiYn == constants.PARAM.SELECT.N ? cmpl[$i18n.locale+'Title'] : cmpl.titl}}</span>
                                        <span v-if="cmpl.execDt == null" class="count">{{ $t('COMPLIANCE.POLICY_NAME_CONTENTS_TOTAL', {'tCnt':cmpl.ruleTotCnt})}} <!--전체 0개 규칙--></span>
                                        <span v-else class="count">
                                            <span v-if="cmpl.execDt && cmpl.cmplStat && cmpl.cmplStat === constants.COMPLIANCE_STAT.FAIL" class="error">
                                                {{ $t('COMPLIANCE.POLICY_NAME_CONTENTS_FAIL', {'fCnt':cmpl.failCnt})}}<!--실패 {00}개-->
                                            </span>
                                            {{cmpl.execDt && cmpl.cmplStat && cmpl.cmplStat === constants.COMPLIANCE_STAT.FAIL ? '/' : ''}} {{ $t('COMPLIANCE.POLICY_NAME_CONTENTS_TOTAL', {'tCnt':cmpl.ruleTotCnt})}} <!--전체 0개 규칙-->
                                        </span>
                                    </div>
                                </span>
                                <span class="cell" data-size="status02" data-align="center" v-on:click="moveToDetail(cmpl, $event)">
                                    <span v-if="cmpl.execDt == null" class="icon-tag" data-type="waiting" data-icon="unexamined">{{$t('COMPLIANCE.EVAL_STAT.UNEXAMINED')}}<!--미검사--></span>
                                    <span v-else-if="cmpl.execDt && cmpl.cmplStat && cmpl.cmplStat === constants.COMPLIANCE_STAT.EXAMINING" class="icon-tag" data-type="waiting" data-icon="examining">{{$t('COMPLIANCE.EVAL_STAT.EXAMINING')}}<!--검사중--></span>
                                    <span v-else-if="cmpl.execDt && cmpl.cmplStat && cmpl.cmplStat === constants.COMPLIANCE_STAT.PASS" class="icon-tag" data-type="success">{{$t('COMPLIANCE.EVAL_STAT.PASSED')}}<!--성공--></span>
                                    <span v-else-if="cmpl.execDt && cmpl.cmplStat && cmpl.cmplStat === constants.COMPLIANCE_STAT.FAIL" class="icon-tag" data-type="failer">{{$t('COMPLIANCE.EVAL_STAT.FAILED')}}<!--실패-->
                                        <template v-if="cmpl.execYn && cmpl.execYn === constants.PARAM.SELECT.Y">({{$t('COMPLIANCE.EVAL_STAT.SOLVED')}}<!--해결-->)</template>
                                        <template v-else>({{$t('COMPLIANCE.EVAL_STAT.UNSOLVED')}}<!--미해결-->)</template>
                                    </span>
                                    <span v-else-if="cmpl.execDt && cmpl.cmplStat && cmpl.cmplStat === constants.COMPLIANCE_STAT.ERROR" class="icon-tag" data-type="error">{{$t('COMPLIANCE.EVAL_STAT.ERROR')}}<!--에러--></span>
                                </span>
                                <span class="cell" data-size="score" data-align="center" v-on:click="moveToDetail(cmpl, $event)">
                                    <em>{{cmpl.score}}%</em>
                                </span>
                                <span class="cell" data-size="schedule" data-align="center" v-on:click="moveToDetail(cmpl, $event)">
                                    <span class="icon-status" :data-icon="cmpl.execType && cmpl.execType === 'A' ? 'schedule' : 'not-schedule'" title="스케쥴 적용">{{$t('COMPLIANCE.EVAL_STAT.APPLY_SCHEDULE')}}</span>
                                </span>
                                <span class="cell center" data-size="date" v-on:click="moveToDetail(cmpl, $event)">
                                    <time datetime="">{{convertUtcTimezoneToLocal(cmpl.updtDt)}}</time>
                                </span>
                                <span class="cell center" data-size="date" v-on:click="moveToDetail(cmpl, $event)">
                                    <time datetime="">{{convertUtcTimezoneToLocal(cmpl.execDt)}}</time>
                                </span>
                                <span v-if="getMenuAuth === constants.AUTH_TYPE.EDIT" class="cell" data-size="management" data-align="center" v-on:click="moveToDetail(cmpl, $event)">
                                    <div class="tooltip-management">
                                        <button type="button" class="buttons-icon" data-type="line" data-size="s" data-icon="more" v-on:click="toggleManagement($event)" v-on:blur="hideManagement($event)">{{$t('LABEL.MANAGE')}}</button>
                                        <!-- data-show 유/무 -->

                                        <div class="management-contents">
                                            <ul class="list-actions">
                                                <li>
                                                    <button type="button" class="btn"
                                                        @click="openAccountListPopup(cmpl)">
                                                        {{$t('COMPLIANCE.BUTTON.SET_EVAL_SCOPE')}}<!--검사 범위 설정-->
                                                    </button>
                                                </li>
                                                <li>
                                                    <button type="button" class="btn"
                                                        @click="openAddSchePopup(cmpl)">
                                                        {{$t('COMPLIANCE.BUTTON.SET_SCHEDULE')}}<!--스케줄 설정-->
                                                     </button>
                                                </li>
                                            </ul>

                                        </div>
                                    </div>
                                </span>
                                <span class="cell" data-align="center" v-on:click="moveToDetail(cmpl, $event)">
                                    <span class="icon-detail-disclosure"></span>
                                </span>
                            </div>
                        </div>
                        <div>
                            <pagination
                                ref="pagination"
                                :callSetCurPage="setCurrentPage"
                                :callSetRowsPerPage="setRowsPerPage"
                                :totalPage="paging.totalPage"
                                :currentPage="paging.currentPage"
                                :rowsPerPage="paging.rowPerPage"
                            />
                        </div>
                        <div class="row none with-button" v-if="!pending && cmplList.length === 0">
                            <div class="cells">
                                <div class="cell">
                                    {{$t('COMPLIANCE.NONE')}}
                                    <br><br>
                                    <router-link :to="'/policy'" class="buttons" data-type="line" data-size="s" data-icon-right="open"><span class="open">{{$t('COMPLIANCE.MOVE_POLICY')}}</span></router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </article>
        <div class="cmpl-modal">
            <Modal
                ref="plcySingleModal"
                :okFunction="handleModalOkFunc"
                :callOnHide="handleHideModal"
                :title="modal.popupTitle"
                :message="modal.popupMessage"
                :isShowPopup="modal.isShowPopup"
                :btnOkStyle="modal.btnOkStyle"
                :modalClass="modal.modalClass"
                :isOkDisabled="modal.disableOk"
            >
                <template v-if="modal.popupType === 'addSchePopup'" slot=body-template>
                    <schedule class="mt-4"
                        :cmplId="selObj.cmplId"
                        :callSetScheInfo="setScheInfo"
                    />
                </template>
                <template v-if="modal.popupType === 'accList'" slot=body-template>
                    <GroupSelect class="mt-4"
                        id="account-select"
                        :options="cmplAcntList"
                        :callGetValue="setSelectedAcntList"
                        :preSlctedValue="selectedCmplAccList"
                        :headTitle="$t('COMPLIANCE.LABEL.ASSESSMENT_ACCOUNT')"
                    />
                </template>
                <template v-if="modal.popupType === 'removePlcy'" slot=body-template>
                    <PlcyListToRemove
                        class="mt-4"
                        :plcyList="totalSlctCmplArray"/>
                </template>
            </Modal>
        </div>
    </main>
</template>

<script>
    import { EventBus } from "../common/event-bus";
    import Pagination from '../common/Pagination.vue';
    import _ from "lodash";
    import {mapGetters, mapMutations} from "vuex";
    import Modal from "../common/Modals/Modal.vue";
    import Schedule from "./components/Schedule.vue";
    import GroupSelect from "../common/GroupSelect/GroupSelect.vue";
    import PlcyListToRemove from "./components/PlcyListToRemove.vue";
    import CVendorSelect from "../common/OptionSelect/CVendorSelect.vue"
    export default {
        name: 'Compliance',
        components: {
            Pagination,
            Modal,
            Schedule,
            GroupSelect,
            PlcyListToRemove,
            CVendorSelect
        },
        data() {
            return {
                originAcntList: [],
                originSlctAcntList: [],
                selectedCmplAccList: [],
                cmplAcntList: [],
                cmplScheInfo: {},
                modal: {
                    isShowPopup: false
                },
                cmplList: [],
                checkList: [],
                filterAcc: [],
                searchStat: this.constants.PARAM.SELECT.ALL,
                searchStatHeader: this.constants.PARAM.SELECT.FILTER_ALL,
                searchSvrty: '',
                searchScheType: ['A','M'],
                searchType: '',
                searchTxt: '',
                sortColumn: '',                                // Sort column
                sortOrder: '',                                 // Sort order
                selObj:{},
                pending: false,
                intervalLoop: null,
                isDisableSearchStatHeader: false,
                paging: {
                    currentPage: 1,
                    totalPage: 0,
                    totalItem: 0,
                    rowPerPage: this.constants.NUM.ROW_PER_PAGE
                },
                lastCmplUpdtDt: null,
                cmplCountStatus: {
                    allStatus: 0,
                    examined: 0,
                    examining: 0,
                    unexamied: 0
                },
                accByVendor: {},
                totalSlctCmpl: {},
                totalSlctCmplArray: [],
                disableBatchAction: true,
                eventSource: null,
                eventSourceId: '',
            }
        },
        created: function() {
            this.getHistoryInfo();
            this.getCmplCountStatus();
            this.debounceSlctCmplList = _.debounce(this.slctCmplList, 900);
            this.debouncegetCmplCountStatus = _.debounce(this.getCmplCountStatus, 900);
            this.initSse();
        },
        mounted() {
            this.initMultiFilter();
            this.getAllAccountByCmpn();
            this.debounceSlctCmplList();
        },
        destroyed: function() {
            this.disableAutoRefresh();
        },
        computed: {
            ...mapGetters({
                curCmpnId: 'user/curCmpnId',
                loginUser: 'user/loginUser',
                complianceHistory: 'user/complianceHistory',
                getAllAccountFilterData: 'getAllAccountFilterData',
                sseEventSource: 'sse/sseEventSource',
                sseResponseData: 'sse/sseResponseData',
                isSseEventSourceClosed: 'sse/isSseEventSourceClosed',
                lastEventId: 'sse/lastEventId'
            }),
            getLocale: function() {
                return this.$i18n.locale;
            },
            getMenuAuth: function() {
                //메뉴 별 권한
                let auth = _.find(this.$store.state.GOV_MENU_AUTH, {menuId: this.constants.MENU.COMPLIANCE_ASSESSMENT});
                return auth ? auth.authTypeCd : this.constants.AUTH_TYPE.NONE;
            },
            getCheckInspecting: function() {
                return _.filter(this.checkList, { 'cmplStat': 'R' }).length;
            },
            searchText : {
                get: function(){
                    return this.searchTxt;
                },
                set: function(value) {
                    this.searchTxt = value;
                }
            },
            getFilterStatus: function() {
                return this.searchStat;
            },
            selectCheckAll : {
                get: function () {
                    if (this.checkList && this.cmplList) {
                        return this.checkList.length !== 0 && (this.checkList.length === this.cmplList.length)
                    }
                    return false;
                },
                set: function (value) {

                    var selected = [];

                    if (value) {
                        this.cmplList.forEach(function (cmpl) {
                            selected.push(cmpl);
                        })
                    }
                    this.checkList = selected;
                }
            }
        },
        watch: {
            checkList(newVal) {
                this.totalSlctCmpl[this.paging.currentPage] = newVal;
                this.$nextTick(() => {
                    this.totalSlctCmplArray = _.flatten(Object.values(this.totalSlctCmpl));
                });
            },
            totalSlctCmplArray(newVal) {
                this.disableBatchAction = newVal.length < 1;
            },
            selectedCmplAccList(newVal, olv) {
                if (_.isEqual(newVal, this.originSlctAcntList)) {
                    this.modal.disableOk = true;
                } else {
                    this.modal.disableOk = false;
                }
            },
            curCmpnId: function() {
                const filterData = {
                    totalSlctCmpl: [],
                    currentPage: 1,
                }
                this.getUrlData(filterData);
                this.slctCmplList();
                this.getCmplCountStatus();
                this.initSse();
            },
            getLocale: function() {
                this.updtSelectBox();
            },
            sseResponseData(newVal) {
                if (newVal.indexOf('_complete') !== -1) {
                    this.getCmplList();
                    this.clearTotalSlctCmpl();
                }
            },
            isSseEventSourceClosed: function() {
                this.getCmplList();
                this.clearTotalSlctCmpl();
            }
        },
        beforeRouteLeave(to, from, next) {
            let compliance = { isRecall: false };
            if (to.name === "ComplianceDetail") {
                compliance = this.complianceHistory;
                compliance.totalSlctCmpl = this.totalSlctCmpl;
                compliance.isRecall = true;
            }
            this.setComplianceHistory(compliance);
            next();
        },
        methods: {
            ...mapMutations({
                setComplianceHistory: "user/setComplianceHistory"
            }),
            getPresetAccount(accounts) {
                if (accounts) {
                    return _.filter(this.getAllAccountFilterData, acc => {return accounts.includes(acc.key)})
                }
            },
            getHistoryInfo() {
                // dashboard filter - result status
                switch(this.$route.query.cmplRslt) {
                    case 'F':
                        this.searchStatHeader = this.constants.PARAM.SELECT.FILTER_NON_COMPLIANCE;
                        this.searchStat = this.constants.PARAM.SELECT.NON_COMPLIANCE;
                        break;
                    case 'P':
                        this.searchStatHeader = this.constants.PARAM.SELECT.FILTER_COMPLIANCE;
                        this.searchStat = this.constants.PARAM.SELECT.COMPLIANCE;
                        break;
                }

                // dashboard filter - sevirity
                this.searchSvrty = _.get(this.$route, "query.severity", null);
                this.searchRuleCmplRslt = _.get(this.$route, "query.ruleCmplRslt", null);

                if (this.complianceHistory.isRecall) {
                    this.getUrlData(this.complianceHistory);
                }
            },
            getUrlData(dataFilter) {
                this.filterAcc = dataFilter.filterAcc;
                this.searchStat = dataFilter.searchStat;
                this.searchStatHeader = dataFilter.searchStatHeader;
                this.searchScheType = dataFilter.searchScheType;
                this.searchType = dataFilter.searchType;
                this.searchTxt = dataFilter.searchTxt;
                this.sortColumn = dataFilter.sortColumn;
                this.sortOrder = dataFilter.sortOrder;
                this.paging.currentPage = dataFilter.currentPage;
                this.paging.urlCurPage = dataFilter.currentPage;
                this.paging.totalPage = dataFilter.totalPage;
                this.paging.totalItem = dataFilter.totalItem;
                this.paging.rowPerPage = dataFilter.rowPerPage
                this.totalSlctCmpl = dataFilter.totalSlctCmpl
            },
            changeSearchType(value) {
                this.searchType = value;
                this.paging.currentPage = 1;
                this.debouncegetCmplCountStatus();
                this.slctCmplList();
            },
            changeFilterAcc(value) {
                this.filterAcc = value;
                this.paging.currentPage = 1;
                this.debouncegetCmplCountStatus();
                this.debounceSlctCmplList();
            },
            clickOnSelection(e) {
                const firstChildNode = _.get(e, "target.firstChild.nodeName");
                if (firstChildNode !== "SELECT") return;
                const target = document.getElementsByClassName("menu transition")[0];
                const select = document.getElementsByClassName("selection dropdown")[0];
                if (document.getElementsByClassName("menu visible")[0]) {
                    target.classList.remove("visible");
                    target.classList.add("hidden");

                    select.classList.remove("active");
                } else if(document.getElementsByClassName("menu hidden")[0]) {
                    target.classList.remove("hidden");
                    target.classList.add("visible");
                }
            },
            setSelectedAcntList(selectedList) {
                this.selectedCmplAccList = selectedList;
            },
            setScheInfo(scheInfo) {
                this.cmplScheInfo = {...this.cmplScheInfo, ...scheInfo};
            },
            async openAccountListPopup(cmpl) {
                await this.getCmplAcntList(cmpl);
                this.modal = {
                    cmplId: cmpl.cmplId,
                    popupTitle: this.$t('COMPLIANCE.BUTTON.SET_EVAL_SCOPE'),
                    popupMessage: this.$t('SCOPE.MESSAGE.MAIN_DESC'),
                    isShowPopup: true,
                    popupType: 'accList',
                    disableOk: true,
                    modalClass: "mid-width"
                }
            },
            openAddSchePopup(cmpl) {
                this.selObj = cmpl;
                this.cmplScheInfo = {
                    cmpnId: cmpl.cmpnId,
                    cmplId: cmpl.cmplId,
                    execType: 'A',
                    dt: '00:00',
                    browserTimeZone: moment().format('Z'),
                    peri: 'D',
                    day: null
                };
                this.modal = {
                    popupTitle: this.$t('COMPLIANCE.BUTTON.SET_SCHEDULE'),
                    popupMessage: this.$t('POLICY.ADD_POPUP.CREATE_SCHEDULE'),
                    isShowPopup: true,
                    popupType: 'addSchePopup'
                }
            },
            handleHideModal() {
                if (this.modal.popupType === 'addSchePopup') {
                    this.cmplScheInfo = {};
                } else if (this.modal.popupType === 'addSchePopup') {
                    this.selectedCmplAccList = [];
                    this.originAcntList = [];
                    this.modal.cmplId = "";
                } else if (this.modal.popupType === 'removePlcy') {
                    // this.checkList = [];
                }
                this.modal.isShowPopup = false;
            },
            handleModalOkFunc() {
                if (this.modal.popupType === "addSchePopup") {
                    this.changeSchedule();
                } else if (this.modal.popupType === "accList") {
                    this.changeCmplAccounts();
                } else if (this.modal.popupType === "removePlcy") {
                    this.removeSelectedCmpls();
                }
            },
            setRowsPerPage(rpp) {
                this.paging.rowPerPage = rpp.rowsPerPage;
                this.paging.currentPage = rpp.currentPage;
                this.debounceSlctCmplList();
            },
            handleStatHeader() {
                this.paging.currentPage = 1;
                this.debounceSlctCmplList(false);
            },
            async getCmplCountStatus() {
                const siteCd = this.$store.state.loginUser.siteCd;
                const header = {
                    'cmpnId': this.curCmpnId,
                    siteCd,
                    'searchTxt':    this.searchTxt,
                    'filterAcc':    this.filterAcc,
                    'searchType':   this.searchType
                };
                const url = "/api/governance/cmpl/status";

                const response = await this.http.post(url, JSON.stringify(header))
                if (response.data) {
                        const cnt = response.data.result;
                        this.cmplCountStatus = cnt;
                }
            },
            setCurrentPage(e) {
                this.paging.currentPage = e;
                this.slctCmplList();
            },
            async slctCmplList(refresh,isLimitPage,callback) {
                if(this.pending) return;
                if(!refresh) {
                    this.pending = true;
                }
                const url = "/api/governance/cmpl/list";
                const header = {
                    'cmpnId':       this.curCmpnId,
                    'rowPerPage':   this.paging.rowPerPage,
                    'currentPage':  this.paging.currentPage,
                    'searchTxt':    this.searchTxt,
                    'filterAcc':    this.filterAcc,
                    'searchScheType': this.searchScheType,
                    'sortColumn':   this.sortColumn,
                    'sortOrder':    this.sortOrder,
                    'searchType':   this.searchType,
                    'searchStatHeader': this.searchStatHeader,
                    'severity': this.searchSvrty,
                    'ruleCmplRslt': this.searchRuleCmplRslt,
                    'searchStat': this.searchStat,
                    'isLimitPage': isLimitPage == null ? true : false,
                    totalSlctCmpl: this.totalSlctCmpl
                };
                let history = this.complianceHistory;
                history = {...history, ...header};
                this.setComplianceHistory(history);
                try {
                    const response = await this.http.post(url, JSON.stringify(header));
                    if (response) {
                        if(isLimitPage==null || isLimitPage){
                            this.cmplList = response.data.result;
                            this.paging = response.data.pagination;
                            this.lastCmplUpdtDt = response.data.pagination.lastCmplUpdtDt;
                            _.forEach(this.cmplList, function(p){
                                p.score = (p.ruleTotCnt > 0? parseInt((((p.ruleTotCnt - p.failCnt) / p.ruleTotCnt) * 100).toFixed(0)) : 0);
                                p.vendors = JSON.parse(p.vendorsjs);
                            });

                        }else{
                            callback(response.data.result);
                        }
                    }
                } catch (err) {
                    console.error(err);
                } finally {
                    const curPageSlctCmpl = this.totalSlctCmpl[this.paging.currentPage];
                    if (curPageSlctCmpl) {
                        this.$nextTick(function() {
                            this.checkList = curPageSlctCmpl;
                        });
                    }
                    this.pending = false;
                    this.selectCheckAll = false;
                }
            },
            convertUtcTimezoneToLocal: function(date) {
                return date == null ? '-' : this.Common.convertUtcTimezoneToLocalByLang(date, this.getLocale);
            },
            setSearchText: function(event) {
                this.paging.currentPage = 1;
                this.searchTxt = event.target.nodeName === 'BUTTON' ? event.target.parentElement.getElementsByTagName('INPUT')[0].value : event.target.value;
                this.debounceSlctCmplList();
                this.debouncegetCmplCountStatus();
            },
            clearSearchText() {
                this.searchTxt = '';
                this.paging.currentPage = 1;
                this.slctCmplList();
                this.getCmplCountStatus();
            },
            moveToDetail(cmpl, $event) {
                const {cmplId, rsltId} = cmpl;
                if($event.target.nodeName !== 'BUTTON') {
                    const url = "/compliance/detail";
                    if (rsltId) {
                        this.$router.push({path: url, query: {cmpl: cmplId, rslt: rsltId}});
                    } else {
                        this.$router.push({path: url, query: {cmpl: cmplId}});
                    }
                }
            },
            openRemoveCmplPopup() {
                this.modal = {
                    popupTitle: this.$t('COMPLIANCE.POPUP.TITLE.REMOVE_FROM_EVAL_LIST'),
                    popupMessage: this.$t('COMPLIANCE.POPUP.DESC.REMOVE_FROM_EVAL_LIST'),
                    isShowPopup: true,
                    popupType: 'removePlcy',
                    btnOkStyle: 'danger'
                }
            },
            async removeSelectedCmpls() {
                const cmplList = (this.totalSlctCmplArray || []).filter(cmpl => cmpl.userDefiYn !== this.constants.PARAM.SELECT.N);
                const data = {
                    cmpnId: this.curCmpnId,
                    cmplList: cmplList
                };
                try {
                    this.pending = true;
                    const url = "/api/governance/compliance/remove";
                    await this.http.post(url, data);
                    await this.getCmplCountStatus();
                    this.clearTotalSlctCmpl();
                } catch (err) {
                    console.error("removeSelectedCmpls :", err);
                } finally {
                    this.pending = false;
                    this.slctCmplList();
                }
            },
            downloadListToCSV: function() {
                this.slctCmplList(false,false,callback=>{
                    var cmplListDownload = callback;
                        _.forEach(cmplListDownload, function(p){
                                p.score = (p.ruleCnt > 0? parseInt((((p.ruleCnt - p.failCnt) / p.ruleTotCnt) * 100).toFixed(0)) : 0);
                            });
                let csvText = "";
                // CSV header setting
                csvText += `${this.$t('LABEL.POLICY_NAME')},Schedule,Compliance Score,Applied On,Recently Inspection\n`;

                for(let cmpl of cmplListDownload) {
                    csvText += (cmpl.userDefiYn === this.constants.PARAM.SELECT.N ? cmpl[this.$i18n.locale+'Title'] : cmpl.titl) + ","
                        + cmpl.execType + ","
                        + cmpl.score + ","
                        + (cmpl.updtDt == null ? '-' : this.Common.convertUtcTimezoneToLocal( cmpl.updtDt )) + ","
                        + (cmpl.execDt == null ? '-' : this.Common.convertUtcTimezoneToLocal( cmpl.execDt )) + "\n";

                }

                var exportedFilenmae = "list" + '.csv' || 'export.csv';

                var blob = new Blob(["\ufeff"+csvText], { type: 'text/csv;charset=utf-8;' });
                if (navigator.msSaveBlob) { // IE 10+
                    navigator.msSaveBlob(blob, exportedFilenmae);
                } else {
                    let link = document.createElement("a");
                    if (link.download !== undefined) { // feature detection
                        // Browsers that support HTML5 download attribute
                        let url = URL.createObjectURL(blob);
                        link.setAttribute("href", url);
                        link.setAttribute("download", exportedFilenmae);
                        link.style.visibility = 'hidden';
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    }
                }
                });
            },
            async getCmplAcntList(cmpl) {
                const url = "/api/governance/cmpl/all/acnt";
                const header = {
                    cmpnId: this.curCmpnId,
                    cmplId: cmpl.cmplId
                };
                const result = await this.http.post(url, JSON.stringify(header))
                if(result.status === 200){
                    this.originAcntList = result.data.result.list;

                    let vendors = this.originAcntList.map(item=>{return item.vendor});
                    vendors = _.union(vendors);
                    const tree = [];
                    vendors.forEach((vendor)=>{
                        let children = this.originAcntList.filter(vnode => vnode.vendor === vendor);
                        children = children.map(item=>{return {id: item.accId, label: item.accAlias}});
                        tree.push({id: (vendor || '').toLowerCase(), label: this.Common.getShortName(vendor), children});
                    });
                    this.cmplAcntList = tree;

                    let checkAcntList = [];
                    this.originAcntList.forEach((o) => {
                        if (o.mappingYn === 1) {
                            checkAcntList.push(o.accId);
                        }
                    });
                    this.originSlctAcntList = _.cloneDeep(checkAcntList);
                    this.selectedCmplAccList = checkAcntList;
                }
            },
            // 추가 팝업의 저장
            changeCmplAccounts() {
                const url = "/api/governance/cmpl/target/acnt/change";
                const header = {
                    cmpnId: this.curCmpnId,
                    prntsObjId: this.modal.cmplId,
                    objIdList: this.selectedCmplAccList
                };
                try {
                    this.http.post(url, JSON.stringify(header));
                } catch (err) {
                    console.error("changeCmplAccounts: ", err);
                }
            },
            async changeSchedule() {
                this.pending = true;
                const url = "/api/governance/schedule/upsert";
                const header = this.cmplScheInfo;
                const result = await this.http.post(url, JSON.stringify(header));
                if (result.data.status === 'ok') {
                    EventBus.$emit('toastComment', 'POLICY.TOAST.SET_SCHEDULE');
                    this.autoRefresh();
                }
                this.pending = false;
            },
            async executeSelectedCmpls() {
                this.autoRefresh();
                this.changeStatExaming();
                const url = "/api/governance/compliance/selected";
                const reqData = {
                    'cmpnId': this.curCmpnId,
                    'cmplList': this.totalSlctCmplArray
                };
                try {
                    // EventBus.$emit('toastComment', '검사를 실행하였습니다.');
                    EventBus.$emit('toastComment', this.$t('COMPLIANCE.DETAIL.ASSESSMENT_HAS_BEEN_RUN'));
                    this.pending = true;
                    await this.http.post(url, reqData);
                    this.clearTotalSlctCmpl();
                } catch (err) {
                    console.error("executeSelectedCmpls: ", err);
                } finally {
                    this.pending = false;
                    await this.slctCmplList();
                }
            },
            async executeNewSelectCmpls() {
                // this.autoRefresh();
                this.changeStatExaming();

                this.totalSlctCmplArray.forEach(item => {

                    item.rsltId = this.Common.uuid();
                });
                const url = "/api/governance/compliance/selected/v1";
                const reqData = {
                    'cmpnId': this.curCmpnId,
                    'cmplList': this.totalSlctCmplArray
                };
                try {
                    EventBus.$emit('toastComment', this.$t('COMPLIANCE.DETAIL.ASSESSMENT_HAS_BEEN_RUN'));
                    this.pending = true;
                    await this.http.post(url, reqData);
                    this.clearTotalSlctCmpl();
                } catch (err) {
                    console.error("executeSelectedCmpls: ", err);
                } finally {
                    this.pending = false;
                    // await this.slctCmplList();
                }
            },

            // 선택한 Column으로 Rule 리스트 Sorting
            setSortColumn: function (targetColumn) {
                const sortObj = this.Common.setSortColumn(this.sortColumn, this.sortOrder, targetColumn);
                this.sortColumn = sortObj.sortColumn;
                this.sortOrder = sortObj.sortOrder;
                this.slctCmplList();
            },
            setFilterStatus: function(status) {
                this.isDisableSearchStatHeader = true;
                switch (status) {
                    case this.constants.PARAM.SELECT.COMPLIANCE:
                        this.searchStatHeader = this.constants.PARAM.SELECT.FILTER_COMPLIANCE;
                        break;
                    case this.constants.PARAM.SELECT.NON_COMPLIANCE:
                        this.searchStatHeader = this.constants.PARAM.SELECT.FILTER_NON_COMPLIANCE;
                        this.isDisableSearchStatHeader = false;
                        break;
                    case 'A':
                        this.searchStatHeader = this.constants.PARAM.SELECT.FILTER_ALL;
                        this.isDisableSearchStatHeader = false;
                }
                this.searchStat = status;

                //reset search variable
                this.sortColumn = '';
                this.sortOrder = '';
                this.paging.currentPage = 1;
                //evoke query
                this.slctCmplList();
            },
            updtSelectBox: function() {
                // 다국어를 위해서.. 바꿔준다... 아놔
                $('.type-checkbox').dropdown({useLabels: false, placeholder: this.$t('LABEL.SELECT_ACCOUNT')});

            },
            toggleManagement: function(event){
                $(event.target).toggleAttr('data-show', '')
            },
            initMultiFilter: function() {

                // tooltipster 생성
                let $filterTarget = $('.tbl-collapse .buttons-tbl-header[data-type=filter]')

                $filterTarget.tooltipster({
                    animation: 'fade',
                    side: 'bottom',
                    theme: 'go-filter',
                    interactive: true,
                    trigger: 'click',
                    functionBefore: function(instance, helper) {
                        $(helper.origin).addClass("selected");
                    },
                    functionAfter: function(instance, helper) {
                        $(helper.origin).removeClass("selected");
                    },
                    functionPosition: function(instance, helper, position) {
                        position.coord.top -= 7;
                        position.coord.left = helper.geo.origin.offset.right - position.size.width;
                        return position;
                    }
                });

            },
            checkRow: function(value) {
                return !_.isEmpty(_.find(this.checkList, {cmplId: value.cmplId}))
            },
            hideManagement: function(event){
                $(event.target).removeAttr('data-show')
            },
            autoRefresh: function(){
                const self = this;
                this.intervalLoop = setTimeout(function () {
                        self.getCmplCountStatus();
                        self.slctCmplList(true);
                    }, 5000);
            },

            disableAutoRefresh: function() {
                clearTimeout(this.intervalLoop)
            },
            clearTotalSlctCmpl: function() {
                this.checkList = [];
                this.totalSlctCmpl = [];
                this.totalSlctCmplArray = [];
            },
            changeStatExaming: function() {
                let self = this;
                _.find(this.cmplList, function(o){
                    _.includes(self.checkList, o) ? o.cmplStat = self.constants.COMPLIANCE_STAT.EXAMINING : false
                })
            },
            getAllAccountByCmpn: function () {
                let url = `/api/governance/all/acnt`;
                let header = {
                    "cmpnId": this.curCmpnId,
                };
                let self = this;
                this.http.post(url, JSON.stringify(header))
                    .then(result => {
                        if (result.status === 200) {
                            _.forEach(result.data.result.list, function(o){
                                self.accByVendor[o.accId] =  o.vendor;
                            })
                        }
                    });
            },
            getVendorIcon(value) {
                switch (value.toLowerCase()) {
                case this.constants.VENDOR.AZURE.toLowerCase():
                    return "azure"

                default:
                    return value.toLowerCase();
                }
            },
            getCmplList() {
                this.getHistoryInfo();
                this.getCmplCountStatus();
                this.slctCmplList();
            },
            initSse() {
                let payload = {
                    cmpnId : this.curCmpnId,
                    menuName : 'compliance'
                }
                if (!this.sseEventSource || (this.curCmpnId !== this.getCmpnIdInLastEventId(this.lastEventId))) {
                    this.$store.dispatch('sse/completeSseEventSource');
                    this.$store.dispatch('sse/createSseEventSource', payload);
                }
            },
            getCmpnIdInLastEventId(lastEventId) {
                return lastEventId.substring(0, lastEventId.indexOf('_'));
            }
        }
    }
</script>

<style scoped>
.account-filter >>> .multiselect {
    min-height: 32px;
}
.disable-search-stat-header {
    color: #bfbfbf;
    cursor: default;
}
</style>



// WEBPACK FOOTER //
// src/components/compliance/compliance.vue